import { env } from 'config/env'

type ApiUrlMap = Record<(typeof env)['NEXT_PUBLIC_ENV'], string>

const railsUrlMap: ApiUrlMap = {
  local: 'http://localhost:3000/',
  staging: 'https://oms.beta.omens.com.br/',
  production: 'https://oms.omens.com.br/'
}

const nestUrlMap: ApiUrlMap = {
  local: 'http://localhost:3333/',
  staging: 'https://api.beta.omens.com.br/',
  production: 'https://api.omens.com.br/'
}

const withTrailingSlash = (url: string) => (url.endsWith('/') ? url : `${url}/`)

export const RAILS_API_URL = withTrailingSlash(
  process.env.NEXT_PUBLIC_RAILS_API_URL || railsUrlMap[env.NEXT_PUBLIC_ENV]
)
export const NEST_API_URL = withTrailingSlash(
  process.env.NEXT_PUBLIC_NEST_API_URL || nestUrlMap[env.NEXT_PUBLIC_ENV]
)
